/**
 * Theme's header js file
 * May handle header logic
 * TODO: Muss komplett refactored werden!!!
 */
(function($, d, w) {

	let _w = $(w);
	let audioIntervalFadein;
	let audioIntervalFadeout;
	let audioVolFadein = 0;
	let audioVolFadeout = 1;

	let isProjectFixedElementsFixed = false;
	let isProjectFixedElementsFixedTimeout1;
	let isProjectFixedElementsFixedTimeout2;

	let lastScrollDirection = 0;

	let scrollAnimating = false;
	let windowScrollTop;
	let projectTopBar;
	let projectTopBarOffsetTopOnWindowTop;
	let header;
	let projectNav;
	let projectNavLink;
	let projectCategories;
	let projectBackground;
	let projectBackgroundInner;
	let burger;
	let burgerLogo;
	let windowHeight;
	let breakpointHeightProject = 680;
	let fixMailContainer;
	let projectContent;
	let projectBackgroundTranslateY;

	$(d).on('zp-ready', init);


	function init() {

		onBurgerClick();
		onMenuItemHover();
		onWindowScroll();
		onWindowResize();
		// handleMenuAudio();
		// onFullscreenClick();

	}

	function onBurgerClick () {

		let burger = $('#zp-burger');
		let header = $('#zp-header');
		let menu = $('#zp-menu');
		// let closeMenu = $('#close-menu, #zp-menu-moving-close-button');
		let closeMenu = $('#close-menu, #zp-menu-image-segments');

		let movingCloseButton = $('#zp-menu-moving-close-button');

		let timeMultiplicator = 1.1;

		let menuBackgroundSegment = $('.zp-menu-background-segment');

		burger.on('click', (e) => {

			$('html').addClass('overflow-hidden');

			movingCloseButton.css('top', (e.clientY-15)+'px');
			movingCloseButton.css('left', (e.clientX-15)+'px');
			menu.on('mousemove', (e) => {
				movingCloseButton.css('top', (e.clientY-15)+'px');
				movingCloseButton.css('left', (e.clientX-15)+'px');
			});

			menu.removeClass('nav-inactive');
			menu.addClass('nav-active');
			header.removeClass('nav-inactive');
			header.addClass('nav-active');

			menuBackgroundSegment.each((index, segment) => {
				setTimeout(() => {

					let _segment = $(segment);
					_segment.addClass('zp-menu-background-segment-animate');

				}, (index*index)*timeMultiplicator);
			});



			setTimeout(() => {

				menu.addClass('finished-animation-black-background');

			}, menuBackgroundSegment.length*timeMultiplicator);

		});

		closeMenu.on('click', () => {

			$('html').removeClass('overflow-hidden');

			menu.off('mousemove');

			//Close Menu
			header.removeClass('nav-active');
			header.addClass('nav-inactive');

			menuBackgroundSegment.each((index, segment) => {
				setTimeout(() => {

					let _segment = $(segment);
					_segment.removeClass('zp-menu-background-segment-animate');

				}, (index*index)*timeMultiplicator);
			});

			menu.removeClass('finished-animation-black-background');

			setTimeout(() => {

				menu.removeClass('nav-active');
				menu.addClass('nav-inactive');

			}, (menuBackgroundSegment.length*menuBackgroundSegment.length)*timeMultiplicator);

		});

	}
	function onMenuItemHover () {

		// let menuItemTitle = $('.menu-item a .title');
		let menuItem = $('.menu-item a');

		menuItem.on('mouseover', schowMenuItemImage);
		menuItem.on('mouseleave', hideMenuItemImage);

	}

	function schowMenuItemImage (event) {

		let menuItem = $(event.currentTarget);
		let menuItemimage = menuItem.attr('data-image');

		let segments = $('#zp-menu-image-segments .zp-menu-image-segment.show-image'); console.log(segments);
		let randomSegment = segments[Math.floor((Math.random() * segments.length))];

		let _randomSegment = $(randomSegment);
		_randomSegment.css('background-image','url("'+menuItemimage+'")');
		_randomSegment.addClass('zp-menu-image-segment-animate');

	}
	function hideMenuItemImage () {

		let segments = $('#zp-menu-image-segments .zp-menu-image-segment');
		segments.removeClass('zp-menu-image-segment-animate');

	}

	function onWindowScroll () {

		let isProjectSite = $('html').hasClass('site-project');
		let isFrontPage = $('html').hasClass('front-page');
		lastScrollDirection = _w.scrollTop();
		if (isProjectSite) {
			scrollProject();
			_w.on('scroll', scrollProject);
		}
		else if (isFrontPage) {
			// headerToTop();
			// _w.on('scroll', () => {
			// 	headerToTop();
			// });
			//siehe start-slider.js
			// swapLogoOnFrontPage();
			// _w.on('scroll', swapLogoOnFrontPage);
		}
		else {
			if (typeof header === 'undefined')
				header = $('#zp-header');
			if (typeof projectNavLink === 'undefined')
				projectNavLink = $('.zp-project-nav-link');

			header.addClass('fixed');
			projectNavLink.addClass('fixed');
			swapLogo();
			_w.on('scroll', () => {
				swapLogo();
			});
		}

	}

	function onWindowResize () {

		let isProjectSite = $('html').hasClass('site-project');
		let isFrontPage = $('html').hasClass('front-page');
		if (isProjectSite) {
			let logoBurger = $('#zp-logo-burger');
			logoBurger.addClass('visible');
			logoBurger.removeClass('hidden');
			scrollProject();
			_w.on('resize', scrollProject);
		}
		else if (isFrontPage) {
			//siehe start-slider.js
			_w.on('resize', () => {
			});
		}
		else {
			_w.on('resize', () => {
				swapLogo();
			});
		}

	}

	function swapLogo () {

		let header = $('#zp-header');
		let logoMain = $('#zp-logo');
		let logoBurger = $('#zp-logo-burger');
		let burger = $('#zp-burger');
		let fullscreen = $('#zp-fullscreen');
		let isProjectSite = $('html').hasClass('site-project');


		let headerheight = header.outerHeight();
		let windowScrollPosition = _w.scrollTop();
		let windowWidth = window.innerWidth;
		let windowHeight = window.innerHeight;
		let breakpointWidth = 768;
		// let breakpointHeight = 680;


		if(windowWidth <= breakpointWidth /*|| windowHeight <= breakpointHeight*/) {

			logoBurger.addClass('visible');
			logoBurger.removeClass('hidden');
			burger.addClass('logo-is-visible');
			logoMain.addClass('hidden');
			logoMain.removeClass('visible');
			// header.addClass('small-height');
			fullscreen.removeClass('visible');
			fullscreen.addClass('hidden');

			if (windowScrollPosition >= 100) {
				headerToTop();
			}
		}
		else {

			fullscreen.removeClass('hidden');
			fullscreen.addClass('visible');

			if (windowScrollPosition >= headerheight) {

				logoBurger.addClass('visible');
				logoBurger.removeClass('hidden');
				burger.addClass('logo-is-visible');
				logoMain.addClass('hidden');
				logoMain.removeClass('visible');
				// header.addClass('small-height');
				// fullscreen.removeClass('visible');
				// fullscreen.addClass('hidden');


			}
			else {

				if (!isProjectSite) {
					logoBurger.addClass('hidden');
					logoBurger.removeClass('visible');
					burger.removeClass('logo-is-visible');
					logoMain.addClass('visible');
					logoMain.removeClass('hidden');
				}
				else {
					logoBurger.addClass('visible');
					logoBurger.removeClass('hidden');
					burger.addClass('logo-is-visible');
					logoMain.addClass('hidden');
					logoMain.removeClass('visible');
				}
				// header.removeClass('small-height');
				// fullscreen.removeClass('hidden');
				// fullscreen.addClass('visible');

			}

		}

	}

	function headerToTop () {

		// console.log(lastScrollDirection)

		if (typeof header === 'undefined')
			header = $('#zp-header');
		if (typeof projectNavLink === 'undefined')
			projectNavLink = $('.zp-project-nav-link');

		if (lastScrollDirection < _w.scrollTop()) {
			// console.log(lastScrollDirection, _w.scrollTop());
			header.addClass('to-top');
			projectNavLink.addClass('to-top');
		}
		else {
			// console.log(lastScrollDirection, _w.scrollTop());
			header.removeClass('to-top');
			projectNavLink.removeClass('to-top');
		}
		lastScrollDirection = _w.scrollTop();

	}

	function handleMenuAudio () {

		lowLag.init();
		playAudios();

		let menuItem = $('.menu-item a');

		menuItem.on('mouseover', audioVolumeUp);
		menuItem.on('mouseleave', audioVolumeDown);

	}

	function playAudios () {

		let menuAudio = $('#menu-audio');
		let menuItems = $('.menu-item');
		let sources = [];

		menuItems.each((index, item) => {

			let _item = $('#'+item.id+' a');

			if (_item.attr('data-audio')) {

				//Audio-Element noch nicht vorhanden
				if (sources.indexOf(_item.attr('data-audio'))) {
					let audio = menuAudio.append( "<audio class='audio-"+item.id+"'><source src='"+_item.attr('data-audio')+"'></audio>" );
					audio.children().last()[0].volume = 1;

					sources.push(_item.attr('data-audio'));
				}
				//Audio-Element bereits vorhanden
				else {
					let audio = $('#menu-audio source[src="'+_item.attr('data-audio')+'"]').parent();
					// console.log(audio.parent());
					audio.addClass('audio-'+item.id);
				}

			}

			if (index == menuItems.length-1) {

				let menuAudios = $('#menu-audio audio');
				menuAudios.each((index, audio) => {
					// let _audio = $(audio);
					// console.log(_audio.children()[0]);
					// lowLag.load(_audio.children().attr('src'));
				});

			}


		});

	}

	function audioVolumeUp (event) {

		let _this = $(this);
		let attr = _this.attr('data-audio');

		if (typeof attr !== typeof undefined && attr !== false) {

			let id = this.parentNode.id;
			let audioSources = $('#menu-audio .audio-'+id)[0];

			audioSources.play();

		}

	}
	function audioVolumeDown (event) {

		let _this = $(this);
		let attr = _this.attr('data-audio');

		if (typeof attr !== typeof undefined && attr !== false) {

			let id = this.parentNode.id;
			let audioSources = $('#menu-audio .audio-'+id)[0];

			// audioSources.pause();
			// audioSources.volume = 0;

		}

	}

	function onFullscreenClick() {

		let fullscreenButton = $("#zp-header .zp-fullscreen");

		fullscreenButton.on('click', function() {
			if(IsFullScreenCurrently())
				goOutFullscreen();
			else
				goInFullscreen(document.documentElement);
		});

	}

	function IsFullScreenCurrently() {
		return (document.fullscreen || document.webkitIsFullScreen || document.mozFullScreen);
	}

	function goInFullscreen (element) {

		let fullscreenButton = $("#zp-header .zp-fullscreen");
		fullscreenButton.addClass('is-fullscreen');

		if (element.requestFullscreen)
			element.requestFullscreen();
		else if(element.mozRequestFullScreen)
			element.mozRequestFullScreen();
		else if (element.webkitRequestFullscreen)
			element.webkitRequestFullscreen();
		else if (element.msRequestFullscreen)
			element.msRequestFullscreen();
	}

	function goOutFullscreen() {

		let fullscreenButton = $("#zp-header .zp-fullscreen");
		fullscreenButton.removeClass('is-fullscreen');

		if (document.exitFullscreen)
			document.exitFullscreen();
		else if (document.mozCancelFullScreen)
			document.mozCancelFullScreen();
		else if (document.webkitExitFullscreen)
			document.webkitExitFullscreen();
		else if (document.msExitFullscreen)
			document.msExitFullscreen();
	}


	function scrollProject() {


		if (typeof projectTopBar === 'undefined')
			projectTopBar = $('#zp-project-top-bar');

		windowScrollTop = _w.scrollTop();
		projectTopBarOffsetTopOnWindowTop = projectTopBar.offset().top-windowScrollTop;
		windowHeight = window.innerHeight;

		if (typeof header === 'undefined')
			header = $('#zp-header');
		if (typeof projectNav === 'undefined')
			projectNav = $('.zp-project-nav');
		if (typeof projectCategories === 'undefined')
			projectCategories = $('#zp-project-categories');
		if (typeof projectBackground === 'undefined')
			projectBackground = $('#zp-project-background');
		if (typeof projectBackgroundInner === 'undefined')
			projectBackgroundInner = $('#zp-project-background-inner');
		if (typeof fixMailContainer === 'undefined')
			fixMailContainer = $('#zp-fix-mail-container');
		if (typeof projectContent === 'undefined')
			projectContent = $('#zp-project-content');
		if (typeof projectNavLink === 'undefined')
			projectNavLink = $('.zp-project-nav-link');
		if (typeof burger === 'undefined')
			burger = $('#zp-burger');
		if (typeof burgerLogo === 'undefined')
			burgerLogo = $('#zp-logo-burger');




		projectBackgroundTranslateY = parseInt(windowScrollTop/3);

		requestAnimation();
	}

	function requestAnimation() {
		if(!scrollAnimating) {
			requestAnimationFrame(draw);
			// draw();
		}

		scrollAnimating = true;
	}
	function draw () {

		scrollAnimating = false;


		//"#zp-project-content" berührt Fenster oben
		if (projectTopBarOffsetTopOnWindowTop <= 0) {

			header.addClass('fixed');
			projectNav.addClass('fixed');
			projectNav.removeClass('compressed');
			fixMailContainer.addClass('fixed');
			fixMailContainer.removeClass('compressed');
			projectTopBar.removeClass('compressed');
			header.removeClass('compressed');
			projectBackground.addClass('hidden');
			// console.log('1. AUS!');

			if (projectTopBarOffsetTopOnWindowTop <= -25) {
				projectCategories.addClass('hidden');
			}
			if (projectTopBarOffsetTopOnWindowTop <= -100) {
				headerToTop();
			}
			else {
				projectCategories.removeClass('hidden');
			}


		}
		else {
			header.removeClass('fixed');
			projectCategories.removeClass('hidden');
			fixMailContainer.removeClass('fixed');
			projectNav.removeClass('fixed');

			if (projectTopBarOffsetTopOnWindowTop <= 25) {
				projectTopBar.removeClass('compressed');
				projectNav.removeClass('compressed');
				header.removeClass('compressed');
				fixMailContainer.removeClass('compressed');
				projectBackground.addClass('hidden');
				// console.log('2. AUS!');
			}
			else if (projectTopBarOffsetTopOnWindowTop > 25) {
				projectTopBar.addClass('compressed');
				projectNav.addClass('compressed');
				header.addClass('compressed');
				fixMailContainer.addClass('compressed');
				projectBackground.removeClass('hidden');
				// console.log('AN!');
			}

			projectBackground.css('transform','translateY(-'+projectBackgroundTranslateY+'px)');
		}

	}

	// function audioVolumeUp (event) {
    //
	// 	let _this = $(this);
	// 	let attr = _this.attr('data-audio');
    //
	// 	if (typeof attr !== typeof undefined && attr !== false) {
    //
	// 		clearInterval(audioIntervalFadeout);
	// 		let id = this.parentNode.id;
	// 		let audioSources = $('#menu-audio .audio-'+id)[0];
    //
	// 		audioIntervalFadein = setInterval( () => {
    //
	// 			audioVolFadein += 0.03;
	// 			if (audioVolFadein < 1) {
	// 				console.log(audioVolFadein);
	// 				audioSources.volume = audioVolFadein;
	// 			}
	// 			else {
	// 				audioSources.volume = 1;
	// 				clearInterval(audioIntervalFadein);
	// 				audioVolFadein = 0;
	// 			}
	// 		}, 50);
    //
	// 	}
    //
	// }
	// function audioVolumeDown (event) {
    //
	// 	let _this = $(this);
	// 	let attr = _this.attr('data-audio');
    //
	// 	if (typeof attr !== typeof undefined && attr !== false) {
    //
	// 		clearInterval(audioIntervalFadein);
	// 		audioVolFadeout = audioVolFadein;
	// 		audioVolFadein = 0;
	// 		let id = this.parentNode.id;
	// 		let audioSources = $('#menu-audio .audio-'+id)[0];
    //
	// 		audioIntervalFadeout = setInterval( () => {
    //
	// 			audioVolFadeout -= 0.03;
	// 			if (audioVolFadeout > 0) {
	// 				console.log(audioVolFadeout);
	// 				audioSources.volume = audioVolFadeout;
	// 			}
	// 			else {
	// 				audioSources.volume = 0;
	// 				clearInterval(audioIntervalFadeout);
	// 				audioVolFadeout = 1;
	// 			}
	// 		}, 50);
    //
	// 	}
    //
	// }

}(jQuery, document, window));